import React from 'react'

import Link from 'next/link'
import Image from 'next/image'
import { usePathname } from 'next/navigation'

import ICONS from '@/assets/icons'
import { useAppSelector } from '@/hooks'

const ItemMenuData = [
  {
    id: 1,
    label: 'Home',
    icon: ICONS.home,
    active: ICONS.homeActive,
    path: '/feed',
  },
  { id: 7, label: 'Events', icon: ICONS.event, active: ICONS.eventActive, path: '/events' },
  {
    id: 6,
    label: 'KOLs',
    icon: ICONS.starKOL,
    active: ICONS.starKOLActive,
    path: '/kol',
  },
  // {
  //   id: 2,
  //   label: 'Message',
  //   icon: ICONS.message,
  //   active: ICONS.messageActive,
  //   path: '/message',
  // },
  {
    id: 3,
    label: 'Wallet',
    icon: ICONS.wallet,
    active: ICONS.walletActive,
    path: '/wallet',
  },

  // {
  //     id: 4,
  //     label: 'Explore',
  //     icon: ICONS.explore,
  //     active: ICONS.exploreActive,
  //     path: '/explore',
  // },
  {
    id: 5,
    label: 'More',
    icon: ICONS.user,
    active: ICONS.usersActive,
    path: '/profile',
  },
]
function NavigationComponents() {
  const pathName = usePathname()
  const spaceActive = useAppSelector((state) => state.root.settings.spaceActive)

  return (
    <section className="fixed bottom-0 z-[47] h-16 w-full border-t border-white/10 bg-ss-dark lg:hidden">
      <div className="flex h-full w-full items-center justify-between px-10">
        {ItemMenuData.map((item) => {
          const isActive = pathName.includes(item.path)
          if (item.id === 5 && spaceActive) {
            return (
              <Link key={item.id} className="flex items-center gap-2" href={`/my-space`}>
                <Image src={isActive ? item.active : item.icon} alt={item.label} width={24} height={24} />
              </Link>
            )
          }
          return (
            <Link key={item.id} className="flex items-center gap-2" href={item.path}>
              <Image src={isActive ? item.active : item.icon} alt={item.label} width={24} height={24} />
            </Link>
          )
        })}
      </div>
    </section>
  )
}

export default NavigationComponents
